import { IAppState } from '@core/store/types'

export const getCategoryNavigation = (state: IAppState) =>
  state.categories.navigation
